
import { Vue, Component, Prop } from 'vue-property-decorator';
import SignUp from '@/features/auth/components/signUp/content/SignUp.vue';
import ConfirmEmail from '@/features/auth/components/signUp/content/ConfirmEmail.vue';
import AboutMe from '@/features/auth/components/signUp/content/AboutMe.vue';
import WhosShipping from '@/features/auth/components/signUp/content/WhosShipping.vue';
import AboutBusiness from '@/features/auth/components/signUp/content/AboutBusiness.vue';
import Experience from '@/features/auth/components/signUp/content/Experience.vue';

@Component({
  components: {
    SignUp,
    ConfirmEmail,
    AboutMe,
    WhosShipping,
    AboutBusiness,
    Experience,
  },
})
export default class SignUpModal extends Vue {
  private step = 1;

  @Prop({ default: false }) showDialog!: boolean;

  private nextStep(): void {
    if (this.step === 5) {
      this.show = false;
      return;
    }

    this.step += 1;
  }

  private previousStep(): void {
    this.step -= 1;
  }

  get show(): boolean {
    return this.showDialog;
  }

  set show(value: boolean) {
    this.$emit('closed', value);
  }
}
